module.exports = __webpack_public_path__ + "img/碳中和交易管理平台.8461d46b.png";